import { SUPPLIER_SERVICE_NAME, SupplierServiceProvider } from './supplier.service'

export const SUPPLIER_SERVICES_MODULE_NAME = 'simax.services.supplier'

const module = angular.module(SUPPLIER_SERVICES_MODULE_NAME, [])

module.provider(SUPPLIER_SERVICE_NAME, SupplierServiceProvider)
